module.exports = __webpack_public_path__ + "img/planner-eezy-work-icon.4047dc8.png";